module.exports = __webpack_public_path__ + "static/img/zhihui-6.55a5c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-6.png
// module id = Lh3F
// module chunks = 46